/**
 * Inbox UI preferences (column widths, etc.) — skeleton API.
 * Replace with GET/PATCH /users/me/preferences or tenant settings API.
 */
import { INBOX_LAYOUT_STORAGE_KEY } from "@/pages/chat/inboxLayoutConfig";

const stubDelay = (ms = 15) => new Promise((r) => setTimeout(r, ms));

/**
 * @returns {Promise<{ data: { left: number, right: number } | null }>}
 */
export async function getInboxColumnWidths() {
  await stubDelay();
  if (typeof window === "undefined") return { data: null };
  try {
    const raw = window.localStorage.getItem(INBOX_LAYOUT_STORAGE_KEY);
    if (!raw) return { data: null };
    const parsed = JSON.parse(raw);
    if (typeof parsed.left !== "number" || typeof parsed.right !== "number") return { data: null };
    return { data: { left: parsed.left, right: parsed.right } };
  } catch {
    return { data: null };
  }
}

/**
 * @param {{ left: number, right: number }} payload
 */
export async function saveInboxColumnWidths(payload) {
  await stubDelay();
  try {
    window.localStorage.setItem(INBOX_LAYOUT_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
  return { data: { ok: true } };
}
